/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent from '@/Mixins/MixinComponent'

/**************************************************************************************************/
/** @internal Const @name FacilityForm                                                           **/
/**************************************************************************************************/
const FacilityForm = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'FacilityForm', mixins: [MixinComponent],

	props:
	{
		show: Boolean
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states:
			{
				code: '',
				name: ''
			}
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		Clear() : void
		{
			this.states =
			{
				code: '',
				name: ''
			}
		}
	}
})

/**************************************************************************************************/
/** @export Component @name FacilityForm                                                         **/
/**************************************************************************************************/
export default FacilityForm

/**************************************************************************************************/
/** @export Type @name FacilityFormRef                                                           **/
/**************************************************************************************************/
export type FacilityFormRef = InstanceType<typeof FacilityForm>